export default __webpack_public_path__ + "static/media/week3progress.39a2e353.png";